<template>
  <p :class="$b()">
    {{ text }}
  </p>
</template>

<script>
export default {
  name: 'DialogTextSmall',
  props: {
    text: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="postcss">
.DialogTextSmall {
  @apply text-xxs md:text-xs
    pt-sm lg:pt-xs lg:mt-xs;
}
</style>
